<template>
	<div style="width: 100%;background: #fff;height: 600px;" class="d-flex m-2">
		<div style="width: 48%;margin-right: 2%;" class="m-1">
			<div>
				<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-bottom">导出</el-button>
			</div>
			<div>
				<el-table class="mt-3" :data="tableData" style="width: 100%" size="mini" :max-height="maxHeight">
					<el-table-column align="center" prop="id" width="60" label="编号"></el-table-column>
					<el-table-column align="center" label="产品名称" width="160">
						<template slot-scope="scope">
							{{scope.row.cpid.cpmc}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="产品编码">
						<template slot-scope="scope">
							{{scope.row.cpid.cpbm}}
						</template>
					</el-table-column>
					<el-table-column align="center" prop="ggmc" label="规格名称"></el-table-column>
					<el-table-column align="center" prop="ggbm" label="规格编码"></el-table-column>
					<el-table-column align="center" prop="kcsl" label="数量"></el-table-column>
					<el-table-column align="center" prop="dw" label="单位"></el-table-column>
				</el-table>
			</div>
		</div>
		<div style="width: 50%;" class="m-1" :max-height="maxHeight">
			<div style="font-weight: 800;">库存统计</div>
			<div ref="myCharta" style="width: 100%; height: 580px;"></div>
		</div>
	</div>
</template>

<script>
import * as vueEcharts from 'echarts';
let echarts = require('echarts');
export default {
	data() {
		return {
			myChart: null,
			tableData: [],
			tjname:[],
			tjnum:[],
			maxHeight: 0,
		};
	},
	mounted() {
		// 画统计图
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 290;
		});
		this.drawLine();
		
	},
	created() {
		this.axios.get('/admin/kccptj', { token: true }).then(res => {
			let list = res.data.data;
			this.tableData = list
			var name = []
			var num = []
			for(let i of list){
				name.push(i.cpid.cpmc)
				num.push(i.kcsl)
			}
			this.tjname = name
			this.tjnum = num
		});
		
		
	},
	methods: {
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: that.tjname,
						inverse:true
					},
					series: [
						{
							name: '2022',
							type: 'bar',
							data: that.tjnum
						}
					]
				});
			}, 1000);
		}
	}
};
</script>

<style></style>
